// @ts-ignore
import React, { Ref, useRef, useState } from 'react';
// @ts-ignore
import { SelectFactory } from "../select/index.tsx";
// @ts-ignore
import { InputFactory } from "../input/index.tsx";
import './main.scss';
import { Api } from "../../api";
import { CalendarScheduler } from "../calendar";
import Modal from "react-bootstrap/Modal";
import Button from 'react-bootstrap/Button';
import "bootstrap/dist/css/bootstrap.min.css";
import Course from '../../objects/Course';
import moment from 'moment-timezone';
import Category from "../../objects/Category";
import Location from "../../objects/Location";
import { FormGenerator } from "../form";
import Cart, { Reservation } from "../../objects/Cart";
import Event from '../../objects/Event';
import { Alert, Col, Row, Table } from 'react-bootstrap';
import { MiniCalendar, FatEvent } from '../minicalendar/minicalendar';
import { Container } from 'reactstrap';
import * as Icon from 'react-bootstrap-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Scroll, { Link, animateScroll as scroll } from "react-scroll";
var Element = Scroll.Element;
var scroller = Scroll.scroller;
moment.tz.setDefault("Europe/London");

interface MainInterface {
    courses: any;
    courses_all: any;
    courses_from_category: any;
    categories: any;
    localizations: any;
    localizations_all: any;
    events: any;
    modal_shown: boolean;
    modal_header: string | null;
    modal_content: any | null;
    modal_footer: string | null;
    course_select_disabled: boolean;
    city_id: number | null;
    selected_course: Course | null;
    selected_category: any | null;
    cart: Cart;
    selected_date: string;
    selected_localization: any | null;
    selected_localization_id: number;
    form_shown_once: boolean;
}

export interface OfferCourseBinding {
    source: number
    destinations: number[]
}

class Main extends React.Component<any, MainInterface>
{
    selected_course_val: SelectFactory = null;


    constructor(props: any) {
        super(props);

        this.state = {
            courses: [],
            courses_all: [],
            courses_from_category: [],
            categories: [],
            localizations: [],
            events: [],
            modal_shown: false,
            modal_header: null,
            modal_content: null,
            modal_footer: null,
            localizations_all: [],
            course_select_disabled: false,
            city_id: null,
            selected_course: null,
            selected_category: null,
            selected_localization: null,
            selected_localization_id: -1,
            cart: new Cart(),
            selected_date: 'initial_fake_date',
            form_shown_once: false
        };

        localStorage.removeItem('form')
        localStorage.removeItem('selected_courses')
    }

    async componentDidMount() {
        this.setState({
            courses: await Api.get_courses(),
            categories: await Api.get_categories(),
            localizations: await Api.get_localizations(),
            localizations_all: await Api.get_localizations(),
            events: await Api.get_courses_in_time()
        }, () => {
            this.setState({ courses_all: this.state.courses })
            this.parseApiResults()
        });
        this.showAllEvents()

        window.addEventListener('keydown', this.keyMapper)
    }

    keyMapper = (event: any): void => {
        if (event.keyCode === 27) {
            this.setState({ modal_shown: false })
        }
    }

    setCourses = (data: any): void => {
        if (typeof (data) != 'object') {

        } else {
            var available_courses: any = [];
            let courses_dtos: Array<Course> = [];

            data.map((v: any) => {
                let course_dto = new Course(v);
                courses_dtos.push(course_dto);

                available_courses.push({
                    label: course_dto.label,
                    value: course_dto.value,
                    dto: course_dto
                });
            });
        }

        this.setState({ courses: available_courses });
    }

    parseApiResults = (): void => {
        this.setCourses(this.state.courses);

        let available_categories: any = [];
        let categories_dtos: Array<Category> = [];

        this.state.categories.map((v: any) => {
            let category_dto = new Category(v);
            categories_dtos.push(category_dto);

            available_categories.push({
                label: category_dto.label,
                value: category_dto.value,
                dto: category_dto
            });
        });
        this.setState({ categories: available_categories });

        let available_localizations: any = [];

        this.state.localizations.map((v: any, k: any) => {
            available_localizations.push({
                label: v.city,
                value: v.id
            });
        });
        this.setState({ localizations: available_localizations });
    }

    putSelectContainer = (): object => {
        return (
            <div className={"select_container"}>
                <SelectFactory
                    id={"select_category"}
                    label={"1. Wybierz kategorię"}
                    options={this.state.categories}
                    empty_message={"Brak dostępnych kategorii"}
                    onChange={(e: any) => {
                        this.handleSelectChange(e, true)
                    }}
                    value={this.state.selected_category}

                />
                <SelectFactory
                    id={"select_course"}
                    label={"2. Wybierz interesujący Cię kurs"}
                    options={this.state.courses_from_category.length > 0 ? this.state.courses_from_category : this.state.courses}
                    empty_message={"Brak dostępnych kursów"}
                    onChange={(e: any) => {
                        this.handleSelectChange(e, false)
                    }}
                    ref={((ref: any) => this.selected_course_val = ref)}
                    disabled={this.state.selected_category == null}
                    defaultValue={this.state.selected_course}
                    value={this.state.selected_course}
                />
                { /* <SelectFactory
                    id={"select_localization"}
                    label={"3. Lokalizacja"}
                    options={this.state.localizations}
                    onChange={(e: any) => {
                        this.handleLocChange(e)
                    }}
                    value={this.state.selected_localization}
                    empty_message={"Brak dostępnych lokalizacji"}
                /> */ }
                <Button variant="outline-danger" onClick={() => {
                    this.setState({
                        selected_course: null,
                        selected_category: null,
                        selected_localization: null,
                        selected_localization_id: -1
                    })
                    this.clearCoursesFromCategories()
                    this.resetCalendar()
                }}>
                    wyczyść filtry
              </Button>
            </div>
        );
    }

    putDetailsForm = (): null | object => {
        var personal_details: Array<InputFactory> = [];
        var address_details: Array<InputFactory> = [];

        personal_details.push(<InputFactory
            id={"first_name"}
            label={"Imię"}
            placeholder={"Jan"}
            alert_message={"Proszę wypełnić to pole"}
            is_required={true}
        />)

        personal_details.push(<InputFactory
            id={"surrname"}
            label={"Nazwisko"}
            placeholder={"Kowalski"}
            alert_message={"Proszę wypełnić to pole"}
            is_required={true}
        />)

        personal_details.push(<InputFactory
            id={"phone_number"}
            label={"Numer telefonu"}
            placeholder={"+48 512 512 512"}
            alert_message={"Proszę wypełnić to pole"}
            is_required={true}
        />)

        personal_details.push(<InputFactory
            id={"email"}
            label={"Adres e-mail"}
            placeholder={"jan.kowalski@gmail.com"}
            type={"email"}
            alert_message={"Proszę wypełnić to pole"}
            is_required={true}
        />)

        personal_details.push(<InputFactory
            id={"remarks"}
            label={"Opcjonalny komentarz / uwagi"}
            placeholder={""}
            is_required={false}
        />)

        personal_details.push(<InputFactory
            id={"nip"}
            label={"NIP"}
            placeholder={"NIP"}
            is_required={false}
        />)

        personal_details.push(<InputFactory
            id={"pesel"}
            label={"PESEL"}
            placeholder={"PESEL"}
            alert_message={"Proszę wypełnić to pole"}
            is_required={false}
        />)

        return (
            <div className={"details_form"}>
                <FormGenerator
                    id={"personal_details"}
                    label={''}
                    inputs={personal_details}
                    save_button={{
                        label: "Zapisz mnie",
                        onClick: this.saveHandler.bind(this),
                        show: !this.state.cart.isCartEmpty()
                    }}
                />
            </div>
        )
    }

    saveHandler = (): void => {
        this.sendRequest()
    }

    sendRequest = (): void => {
        const request_data = {
            person_details: JSON.parse(localStorage.getItem('form') as string),
            cart: this.state.cart.cart
        }

        Api.send_request(request_data)

        this.showCustomModal('Dziękujemy!', 'Twoje zgłoszenie zostało zapisane');
        this.setState({ cart: new Cart });
    }

    resetCalendar = (): void => {
        this.setCourseSelectStatus(false)
        this.showAllEvents()
    }

    handleLocChange = (event: any) => {
        this.setState({ selected_localization: event, selected_localization_id: event.value });
        this.fetchCourserPerTimeFrame(this.state.selected_course ?? this.state.selected_category ?? null, event.value);
    }

    handleSelectChange = (event: any, reset_courses: boolean) => {
        if (event) {
            if (event.dto instanceof Course) {
                this.fetchCourserPerTimeFrame(event.dto, this.state.selected_localization_id);
                this.setState({ selected_course: event.dto })
            } else if (event.dto instanceof Category) {
                //this.clearCoursesFromCategories();
                this.categorySelectHandler(event.dto);
                this.setState({
                    selected_category: event.dto
                })
            }
        } else if (event.dto instanceof Category) {
            if (reset_courses) {
                this.clearCoursesFromCategories();
            }
            this.setState({
                selected_category: event.dto
            })
            this.setCourses(this.state.courses_all);
            this.setCourseSelectStatus(false);
            this.showAllEvents();
        }
    }

    clearCoursesFromCategories = (): void => {
        this.setState({ courses_from_category: [] })
    }

    clearEvents = (): void => {
        //this.setState({ events: [] });
    }

    categorySelectHandler = (category: Category): void => {
        if (category.is_course == true) {
            this.setCourseSelectStatus(true);
            this.fetchCourserPerTimeFrame(category, this.state.selected_localization_id);
            return;
        } else {
            this.setCourseSelectStatus(false);
            this.clearEvents();
            this.setCoursesFromCategory(category);
        }
    }

    setCoursesFromCategory = (category: Category): void => {
        let available_courses: any = [];

        category.courses.map((course: Course) => {
            available_courses.push({
                label: course.label,
                value: course.value,
                dto: course
            });
        })

        this.setState({ courses_from_category: available_courses });
        this.fetchCourserPerTimeFrame(category, this.state.selected_localization_id);
    }

    setCourseSelectStatus = (isDisabled: boolean): void => {
        this.setState({ course_select_disabled: isDisabled });
    }

    fetchCourserPerTimeFrame = async (course_or_category: Course | Category, loc_id: any): Promise<void> => {
        let list: Array<number> = [];
        this.clearEvents();
        if (course_or_category instanceof Category && course_or_category.courses.length > 0) {
            course_or_category.courses.map((course: Course) => {
                list.push(course.id);
            });
            this.setState({ selected_course: null, events: await Api.get_courses_in_time_w_c_ids(list.join(','), loc_id) });
        } else if (course_or_category instanceof Course) {
            let list2: Array<number> = [course_or_category.id];
            await this.setState({ events: await Api.get_courses_in_time_w_c_ids(list2.join(','), loc_id) });
            this.scrollToCalendarView()
        } else {
            await this.setState({ events: await Api.get_courses_in_time_w_c_ids('', loc_id) });
            this.scrollToCalendarView()
        }
    }

    scrollToCalendarView = (): void => {
        scroller.scrollTo('minicalendar', {
            duration: 1500,
            delay: 0,
            smooth: 'easeInOutQuint',
            offset: -115
        })
    }

    showAllEvents = async (): Promise<void> => {
        this.setState({ events: await Api.get_courses_in_time() });
    }

    putScheduler = (): object => {
        return <div className={"calendar_container"}>
            <CalendarScheduler
                handler={this.eventClickHandler.bind(this)}
                // @ts-ignore
                events={this.state.events}
                courses={this.state.courses_all}
            />
        </div>
    }

    getHoursForCourse = async (course: Course, day: string): Promise<any> => {
        return await Api.get_seats_by_course_city(course.id, this.state.city_id).filter(function (seat: any) {
            return moment.unix(seat.date).format("YYYY-MM-DD") == day;
        })
    }

    eventClickHandler = (fatEvent: FatEvent): void => {
        if (moment.unix(fatEvent.event.start_time).isSameOrBefore(moment())) {
            return;
        }

        scroll.scrollToTop();

        let course: Course = this.state.courses_all.filter((f: Course) => f.id == fatEvent.event.course_id)[0];
        let start = moment.unix(fatEvent.event.start_time).startOf('day')
        let end = moment.unix(fatEvent.event.start_time).endOf('day')

        let seats: Array<any> = [];
        let start_time_dst: number;
        let unix_start_time = moment.unix(fatEvent.event.start_time);

        this.state.events.forEach((event: Event) => {
            if (event.course_id == fatEvent.event.course_id && event.localization == fatEvent.event.localization) {
                if (moment.unix(event.start_time).isSameOrAfter(start) && moment.unix(event.start_time).isSameOrBefore(end)) {
                    start_time_dst = unix_start_time.isDST() ? moment.unix(event.start_time).subtract(1, 'hours').unix() : event.start_time
                    seats.push({ "date": start_time_dst, "localization": event.localization, "event_id": event.id });
                }
            }
        });

        let selected_date = unix_start_time.format("DD.MM.YYYY HH:mm");

        this.showCourseModal(course, fatEvent.event.start_time, seats, fatEvent.localization);

        this.setState({
            'selected_date': selected_date
        })
    }

    showCourseModal = (course: any, date: number, av_seats: any | null, location_id: number) => {
        let city: string = this.state.localizations_all.filter((l: any) => l.id == this.state.selected_localization_id)[0]?.city;

        this.setState({
            modal_shown: true,
            modal_header: (course.course + ' - ' + moment.unix(date).format('DD.MM.YYYY')),
            modal_content: <div>
                <b>{city}</b>
                {this.getSeatsList(av_seats, course, location_id)}
            </div>,
            modal_footer: 'exit'
        });
    }

    showCustomModal = (header: string, content: string) => {
        this.setState({
            modal_shown: true,
            modal_header: header,
            modal_content: <div>
                {content}
            </div>,
            modal_footer: 'exit'
        });
    }

    getSeatsList = (seats: any, course_id: Course, city_id: number): any => {

        return [
            seats.length > 0 ? <div>
                <h6>Godziny rozpoczęcia kursów w wybranym dniu:</h6>
                {
                    seats.map((seat: any) => {
                        let is_already_saved = this.state.cart.isSet(seat.event_id);

                        return <div className={"seat_container"}>
                            <p className={"seat_field seat_field_left"}>
                                {moment.unix(seat.date).format("HH:mm")}
                            </p>
                            {!is_already_saved ?
                                <Button
                                    variant="success"
                                    className={"save_me"}
                                    onClick={() => this.pickCourseSeat(seat.event_id, course_id, seat.date, city_id)}
                                >zapisz&nbsp;się</Button>
                                : <Button className={"minicalendar-reserved"}>zapisano</Button>}

                        </div>
                    })
                }
            </div> : <h6>Brak dostępnych kursów w wybranej lokalizacji.</h6>
        ]
    }

    pickCourseSeat = (event_id: number, course: Course, seat: any, city_id: number): void => {
        this.state.cart.addEntry({ event_id: event_id, course_id: course.id, start_time: seat, loc_id: city_id });
        this.setState({ modal_shown: false })

        const bindings: Array<OfferCourseBinding> = new Array<OfferCourseBinding>();
        //F-gazy
        bindings.push({ source: 13, destinations: [19, 20, 21, 16, 17] })

        //F-gazy - klimatyzacje
        bindings.push({ source: 14, destinations: [19, 20, 21, 16, 17] })

        //Kurs montazu klimatyzacji
        bindings.push({ source: 15, destinations: [19, 20, 21, 16, 17] })

        //Kurs obsługi/napełniania zbiorników ciśnieniowych i butli
        bindings.push({ source: 15, destinations: [19, 20, 21, 17] })

        //Szkolenie Instalatorów Systemów Fotowoltaicznych OZE :
        bindings.push({ source: 15, destinations: [16, 18, 20, 21, 17, 22, 23, 13] })


        //Certyfikowany instalator pomp ciepła OZE :
        bindings.push({ source: 13, destinations: [19, 20, 21, 16, 17] })

        //Szkolenie przygotowujące do egzaminu UDT w zakresie certyfikowanych instalatorów PV //(omawianie i rozwiązywanie zadań,testów i pytań egzaminacyjnych)
        bindings.push({ source: 41, destinations: [19, 20, 21, 16, 13] })

        //SEP G1, G2, G3
        bindings.push({ source: 19, destinations: [22, 17, 18, 23] })
        bindings.push({ source: 20, destinations: [22, 17, 18, 23] })
        bindings.push({ source: 21, destinations: [22, 17, 18, 23] })

        //Szkolenie z pomiarów instalacji elektrycznych
        bindings.push({ source: 23, destinations: [19, 20, 21, 15, 18, 23] })

        //Konserwator wózka
        bindings.push({ source: 24, destinations: [25, 26, 27, 28, 44] })

        //konserwator podestu
        bindings.push({ source: 25, destinations: [24, 26, 27, 28, 44] })

        //konserwator suwnicy
        bindings.push({ source: 26, destinations: [24, 25, 27, 28, 44] })

        //konserwator żurawi ... HDS
        bindings.push({ source: 27, destinations: [24, 25, 26, 28, 44] })

        //konswerwator zuwaria warszt.
        bindings.push({ source: 44, destinations: [19, 24, 25, 26, 27, 28] })

        //Spawanie met. MAG :
        bindings.push({ source: 29, destinations: [30, 31, 32, 33] })


        //Spawanie met. elektr.
        bindings.push({ source: 30, destinations: [29, 31, 32, 33] })


        //Spawanie met. gaz..
        bindings.push({ source: 31, destinations: [29, 30, 32, 33] })

        //Spawanie PE
        bindings.push({ source: 32, destinations: [29, 30, 31, 33] })

        //Spawanie TIG
        bindings.push({ source: 33, destinations: [29, 30, 31, 32] })

        //Wózki jezdniowe podnośnikowe :
        bindings.push({ source: 34, destinations: [35, 36, 37, 38, 39, 40] })

        //Podesty przejezdne
        bindings.push({ source: 35, destinations: [34, 36, 37, 38, 39, 40] })

        //suwnice
        bindings.push({ source: 36, destinations: [35, 35, 37, 38, 39, 40] })

        //Żurawie przewoźne i przenośne – HDS :
        bindings.push({ source: 37, destinations: [35, 35, 36, 38, 39, 40] })

        //hakowy
        bindings.push({ source: 38, destinations: [35, 35, 36, 37, 39, 40] })

        //Wciągniki, wciągarki
        bindings.push({ source: 39, destinations: [35, 35, 36, 37, 38, 40] })

        //Operator żurawia samojezdnego
        bindings.push({ source: 40, destinations: [35, 35, 36, 37, 39, 40] })

        //brak lutowania twardego

        let found: any;
        if ((found = bindings.filter((b: OfferCourseBinding) => b.source == course.id)).length == 1) {
            let offers: JSX.Element[] = found[0].destinations.map((destination: number) => {
                let course = this.state.courses_all.filter((c: any) => c.id == destination)[0];

                return <div className={"seat_container"}>
                    <p className={"seat_field seat_field_left"}>
                        {course.course}
                    </p>
                    {
                        <Button
                            variant="success"
                            className={"save_me"}
                            onClick={() => {
                                this.handleSelectChange({ dto: new Course({ id: course.id, course: course.course }) }, false)
                                this.setState({ modal_shown: false })
                                toast.info('Kalendarz został zaktualizowany', {
                                    position: "top-left",
                                    autoClose: 2000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: false,
                                    draggable: false,
                                    progress: undefined,
                                });
                            }
                            }
                        >pokaż&nbsp;terminy</Button>
                    }
                </div>
            })


            this.setState({
                modal_header: 'Dziękujemy za wybór kursu',
                modal_content: (['Czy może chciałbyś zapisać się na inny kurs?', <br />, offers]),
                modal_shown: true,
                modal_footer: '-'
            })
        }
        //this.eventClickHandler(course.id, this.state.selected_date)

        //this.console.log(this.state.cart.cart)
    }

    putSummary = (): any => {
        return !this.state.cart.isCartEmpty() ?
            (<Col>
                <Table bordered hover>
                    <thead>
                        <th>Kurs</th>
                        <th>Termin</th>
                        <th>-</th>
                    </thead>
                    <tbody>
                        {
                            this.state.cart.cart.map((reservation: Reservation) => {
                                let courseId: number = reservation.course_id;
                                let courseName: string = this.state.courses_all.filter((c: Course) => c.id == courseId)[0].course;
                                reservation.loc_id = reservation.loc_id ?? -1;
                                let localization: Location = this.state.localizations_all.filter((l: Location) => l.id == reservation.loc_id)[0];
                                let start_time: number = reservation.start_time;

                                return (<tr>
                                    <td>
                                        {courseName}
                                    </td>
                                    <td>
                                        {localization?.city}
                                        <br />
                                        {moment.unix(start_time).format("DD.MM.YYYY HH:mm")}
                                    </td>

                                    <td>
                                        <Button onClick={() => { this.state.cart.removeEntry(reservation); this.forceUpdate() }} variant="danger">
                                            <Icon.TrashFill />
                                        </Button>
                                    </td>
                                </tr>)
                            })
                        }

                    </tbody>
                </Table>
                <Button className="pull-right submitBtn" onClick={() => this.detailsModal()} variant="success">Przejdź do formularza zapisu</Button>
            </Col>) : null;
    }


    detailsModal = (): any => {
        this.setState({
            modal_shown: true,
            modal_header: 'Formularz zapisu',
            modal_content: this.putDetailsForm(),
            modal_footer: 'exit'
        });
    }

    render(): any {
        return [
            <ToastContainer
                position="top-left"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable={false}
                pauseOnHover
            />,
            <Modal show={this.state.modal_shown}>
                <Modal.Header>{this.state.modal_header}</Modal.Header>
                <Modal.Body>{this.state.modal_content}</Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-danger" onClick={() => this.setState({ modal_shown: false })}>
                        Zamknij
                    </Button>
                </Modal.Footer>
            </Modal>,
            <Container fluid>
                <Row>
                    <Col xs={3} md={0} lg={3} />
                    <Col xs={12} md={6} lg={6} >
                        <Row>
                            <Col>{this.putSelectContainer()}</Col>
                        </Row>

                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                {this.state.cart.cart.length > 0 ? <h5>Wybrane szkolenia</h5> : null}
                                {this.putSummary()}
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col xs={0} md={3} />
                    <Col xs={12} md={6}>
                        <Element name={'minicalendar'}>
                            <div>
                                {this.state.selected_course != null ? <MiniCalendar cart={this.state.cart} eventClickHandler={this.eventClickHandler.bind(this)} events={this.state.events} locations={this.state.localizations_all} /> : null}
                            </div>
                        </Element>
                    </Col>
                </Row>

            </Container>
        ];
    }
}

export default Main;
